// extracted by mini-css-extract-plugin
export default {"box":"tbd-messages_box__pALhb","item":"tbd-messages_item__HMunK"};